import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import StoreReqModal from "../components/storeReqmodal";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const Addpr_new = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [indent, setIndent] = useState([]);
  const [prNo, setPrNo] = useState('');
  const [indentView, setIndentView] = useState({ }); 
    const [showLifeDetail, setShowLifeDetail] = useState(false);
  const [formData, setFormData] = useState({
    reqBasis: "",
    remark: "",
    indentNumber: "",
    reqBasis : "",
    dept1: "",
    hod: "",
    remarks: "",
    hm: "",
  });
  const [dept, setDept] = useState([]);
  const [selectedIndent, setSelectedIndent] = useState(null);
  const navigate = useNavigate();

  //✅ Permission checks (safe even if perms not yet loaded; will be false)
              const canEntry = hasPermission("purchase-Requisition", "entry");
              /////////////////////////////////////////////////////////////
    

  const handleSelectIndent = (item) => {
    setSelectedIndent(item.indentHeader_number);
  };

  useEffect(() => {
    {canEntry && (
    fetchPrNo()
    )}
  }, []);

  const fetchPrNo = async () => {
    try {
      Swal.fire({
                  title: "Fetching Purchase No",
                  html: `
                    <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                      <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                    </div>
                    <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Purchase No...</p>
                  `,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @keyframes progressBar {
                        0% { width: 0% }
                        50% { width: 100% }
                        100% { width: 0% }
                      }
                    `;
                    document.head.appendChild(style);
                  },
                });
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_No`);
      if (response.data.purNo) {
        const purchaseNo = parseInt(response.data.purNo, 10) || 0;
        setPrNo(purchaseNo.toString());
        setFormData(prevState => ({ ...prevState, newPurNo: purchaseNo.toString() }));
      }
      Swal.close();
    } catch (error) {
      Swal.close();
                console.error("Error fetching Purchase No. Please try again:", error);
                Swal.fire({
                  icon: "error",
                  title: "Oops!",
                  text: "Error fetching Purchase No. Please try again",
                });
    }
  };

  useEffect(() => {
    const fetchDept = async () => {
      try {
         Swal.fire({
                  title: "Fetching Departments",
                  html: `
                    <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                      <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                    </div>
                    <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Departments...</p>
                  `,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @keyframes progressBar {
                        0% { width: 0% }
                        50% { width: 100% }
                        100% { width: 0% }
                      }
                    `;
                    document.head.appendChild(style);
                  },
                });

        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseReq_department?branchId=${branch}`);
        setDept(response.data.purDept || []);
        Swal.close();
      } catch (error) {
        Swal.close();
                console.error("Error fetching Departments. Please try again:", error);
                Swal.fire({
                  icon: "error",
                  title: "Oops!",
                  text: "Error fetching Departments. Please try again",
                });
      }
    };
    {canEntry && (
    fetchDept()
    )}
  }, [branch]);


useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/storeReq_detailsHeader?indentNo=${selectedIndent}&branch=${branch}`
        );

        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;

          const storeReqHeader = {
            dept1: items[0].departmentmaster_name || "",
          };

          setIndentView(storeReqHeader);
          console.log(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
{canEntry && (
    fetchIndentDetails()
)}
}, [selectedIndent, branch]); // Ensure the API call re-runs when these change


  

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseReq_indentDetails?branch=${branch}&indentNo=${selectedIndent}`);
        setIndent(response.data.indentDetails || []);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchIndentDetails();
  }, [branch, selectedIndent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleIndentChange = (index, event) => {
    const { name, value } = event.target;

    setIndent((prevIndent) =>
        prevIndent.map((item, i) =>
            i === index ? { ...item, [name]: value } : item
        )
    );
};

const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIndentView((prev) => ({ ...prev, [name]: value }));
  };



// Function to submit the form data
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!indent || indent.length === 0) {
    Swal.fire("warning", "Please Select the Store Requisition Item", "warning");
    return;
  }

  // ---- basic required-field checks ----
  if (!formData.hod || !formData.hod.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter a HOD!",
    });
    return;
  }

  if (!formData.reqBasis || !formData.reqBasis.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please select your Requirement Basis!",
    });
    return;
  }

  if (!indentView.dept1 || !indentView.dept1.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please select your Department!",
    });
    return;
  }

  if (!formData.hm || !formData.hm.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please select Head Material!",
    });
    return;
  }

  

  // ---- helper to parse date-only (handles yyyy-mm-dd safely) ----
  const parseDateOnly = (val) => {
    if (!val) return null;
    // if string in YYYY-MM-DD format, parse as local date (no timezone shift)
    if (typeof val === "string") {
      const m = val.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) {
        const y = Number(m[1]),
          mo = Number(m[2]) - 1,
          d = Number(m[3]);
        return new Date(y, mo, d);
      }
    }
    // fallback to Date and normalize to date-only
    const parsed = new Date(val);
    if (isNaN(parsed)) return null;
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  };

  // today at 00:00 local
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // ---- item-level validations (use `indent` array which you later map into payload) ----
  for (const item of indent) {
    const itemName =
      item.itemmaster_name || item.itemName || item.itemCode || "this item";

    if (!item.spec || String(item.spec).trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Missing Specification",
        text: `Please enter Specification for ${itemName}`,
      });
      return;
    }

    if (!item.purpose || String(item.purpose).trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Missing Purpose",
        text: `Please enter Purpose for ${itemName}`,
      });
      return;
    }

    // if (!item.lifeDetail || String(item.lifeDetail).trim() === "") {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Missing Life Detail",
    //     text: `Please enter Life Detail for ${itemName}`,
    //   });
    //   return;
    // }

    // due date presence
    if (!item.duedate || String(item.duedate).trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Missing Due Date",
        text: `Please select a due date for ${itemName}.`,
      });
      return;
    }

    // parse and validate due date (today or future only)
    const dueDate = parseDateOnly(item.duedate);
    if (!dueDate) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Due Date",
        text: `Due date for ${itemName} is invalid. Please use YYYY-MM-DD or a valid date.`,
      });
      return;
    }

    if (dueDate < today) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Due Date",
        text: `Due date for ${itemName} must be today or a future date.`,
      });
      return;
    }
  }

  // ---- build payload (keeps your original mapping) ----
  const payload = {
    prNo: formData.newPurNo,
    branch: branch,
    user: userId,
    indentNumber: selectedIndent,
    reqBasis: formData.reqBasis,
    dept: indentView.dept1,
    hod: formData.hod,
    remarks: formData.remark,
    hm: formData.hm,
    items: indent.map((item) => ({
      itemCode: item.indentDetail_itemCode,
      itemName: item.itemmaster_name,
      itemUom: item.itemmaster_uom,
      drawNo: item.itemmaster_drawingNumber,
      price: item.itemmaster_price,
      qty: item.indentDetail_quantity,
      duedate: item.duedate,
      spec: item.spec,
      purpose: item.purpose,
      lifeDetail: item.lifeDetail,
    })),
  };

  // console.log("Payload:", payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/purchaseReq_insert",
      payload
    );

    Swal.fire("Success", "Purchase Requisition added successfully", "success");
    setIndent([]);
    navigate("/inventory/purchasesreqView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};


if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Add Purchase Requisition</h2>
                    <Link to='/inventory/purchasesreqView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

       

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Req No :</label>
                <input type="text" name="indentNo" value={formData.newPurNo} onChange={handleChange} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Indent Ref No :</label>
                <input type="text" name="indentNo" value={selectedIndent} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" name="hod" value={formData.hod} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Requirement Basis:</label>
                <select name="reqBasis" value={formData.reqBasis} onChange={handleChange}>
                  <option value="">-- Select Basis --</option>
                  <option value="Emergency">Emergency</option>
                  <option value="Urgent">Urgent</option>
                  <option value="Ordinary">Ordinary</option>
                </select>
              </div>
              <div className="form-group">
                <label>Department :</label>
                <select name="dept1" value={indentView.dept1} onChange={handleInputChange}>
  <option value="">-- Select Department --</option>
  {dept.map((item, index) => (
    <option key={index} value={item.departmentmaster_name}>
      {item.departmentmaster_name}
    </option>
  ))}
</select>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remark" value={formData.remark} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Head Meterial :</label>
                <input type="text" name="hm" value={formData.hm} onChange={handleChange} />
              </div>
            </div>



          <div className="flex_buttons">
          <button type="button" className="button button-add" onClick={() => setShowModal(true)}> Add Store requisition item</button>
        </div>
            <div className="content-table">
              <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>PartNo</th>
            <th>UOM</th>
            <th>Price</th>
            <th>Qty</th>
            <th>Due Date</th>
            <th>Specification</th>
            <th>Purpose</th>
            <th style={{ textAlign: "center" }}>
              {/* Eye button to toggle */}
              <button
                type="button"
                onClick={() => setShowLifeDetail(!showLifeDetail)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
              {showLifeDetail && <span style={{ marginLeft: "5px" }}>Life Detail</span>}
            </th>
          </tr>
        </thead>
        <tbody>
          {indent.length > 0 ? (
            indent.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.indentDetail_itemCode}</td>
                <td>{item.itemmaster_name}</td>
                <td>{item.itemmaster_drawingNumber}</td>
                <td>{item.itemmaster_uom}</td>
                <td>{item.itemmaster_price}</td>
                <td>{item.indentDetail_quantity}</td>
                <td>
                  <input
                    type="date"
                    name="duedate"
                    value={item.duedate || ""}
                    onChange={(e) => handleIndentChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="spec"
                    value={item.spec || ""}
                    onChange={(e) => handleIndentChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="purpose"
                    value={item.purpose || ""}
                    onChange={(e) => handleIndentChange(index, e)}
                  />
                </td>
                {showLifeDetail && (
                  <td>
                    <input
                      type="text"
                      name="lifeDetail"
                      value={item.lifeDetail || ""}
                      onChange={(e) => handleIndentChange(index, e)}
                    />
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={showLifeDetail ? "12" : "11"}>No items added</td>
            </tr>
          )}
        </tbody>
      </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>

          </form>
        </div>
      </div>
     <StoreReqModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectIndent} />
    </div>
  );
};

export default Addpr_new;